module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.ttf?5b44818d2b9eda3e23cd5edd7b49b7d5";